var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { useSelector } from 'react-redux';
import { NavigationConfig } from '../utils/navigation_config';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import PageNotFound from '../pages/dashboard/pageNotFound/PageNotFound';
import './../assets/scss/authentication.scss';
import { baseColors } from '../Themes/colors';
import { getAccessibleRoutes } from '../utils/permissionUtils';
import LeftMenu from '../components/SideMenu/LeftMenu';
import Header from '../components/header/Header';
var LightTooltip = styled(function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement(Tooltip, __assign({}, props, { classes: { popper: className }, placement: 'top-start', arrow: true })));
})(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(tooltipClasses.tooltip)] = {
            backgroundColor: theme.palette.common.black,
            color: 'white',
            boxShadow: theme.shadows[1],
            fontSize: 11,
            width: 270,
            marginRight: 2
        },
        _b["& .".concat(tooltipClasses.arrow)] = {
            color: theme.palette.common.black,
        },
        _b);
});
var getUser = function (state) { return state.User; };
var CheckAuth = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var navigate = useNavigate();
    var location = useLocation();
    var navConfig = NavigationConfig;
    var isLoggedIn = useSelector(function (state) { return getUser(state).isLoggedIn; });
    var userBasicInfo = useSelector(function (store) { return store.User.userData; });
    var ReduxMainRep = useSelector(function (store) { return store.BacklogFilter.reduxMainResp; });
    var ReduxAppResp = useSelector(function (store) { return store.BacklogFilter.reduxAppResp; });
    var roleType = useSelector(function (store) { var _a; return (_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.RoleType; });
    var helpMail = useSelector(function (store) { return store.User.helpMail; });
    var rolePermissions = useSelector(function (store) { var _a; return ((_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.RolePermissions) || []; });
    var _b = React.useState(false), openNeedhelp = _b[0], setNeedhelp = _b[1];
    var accessibleRoutes = React.useMemo(function () {
        var permissionRoutes = getAccessibleRoutes(rolePermissions);
        var commonRoutes = [
            '/',
            navConfig.Account.Login,
        ];
        var hasAnyViewPermission = rolePermissions.some(function (perm) { return Number(perm.View) === 1; });
        if (hasAnyViewPermission) {
            commonRoutes.push(navConfig.Dashboard);
        }
        if (roleType === "ADMIN") {
            commonRoutes.push(navConfig.CustomerPortalDashboard, navConfig.CustomerPortalUserManagement, navConfig.PaymentManagement, navConfig.DocumentManagement, navConfig.DocumentTypeAccess, navConfig.DocumentSize, navConfig.CustomerPortalSupportManagement, navConfig.BrandCustomization);
        }
        var allRoutes = __spreadArray(__spreadArray([], permissionRoutes, true), commonRoutes, true);
        return Array.from(new Set(allRoutes));
    }, [rolePermissions, navConfig, roleType]);
    React.useEffect(function () {
        checkAuthentication();
    }, [isLoggedIn]);
    function checkAuthentication() {
        if (!isLoggedIn) {
            navigate(navConfig.Account.Login, { state: { from: location.pathname + location.search } });
        }
        else {
            checkAuthorization();
        }
    }
    function checkAuthorization() {
        return true;
    }
    return (React.createElement(Box, { sx: { display: 'flex', minHeight: '100vh', bgcolor: baseColors.successPreset[20] } },
        React.createElement(Box, { sx: { flexShrink: 0, position: 'sticky', top: 0, alignSelf: 'flex-start', height: '100vh', zIndex: 10 } },
            React.createElement(LeftMenu, null)),
        React.createElement(Box, { sx: {
                flex: 1,
                minWidth: 0,
                minHeight: '100vh',
                overflow: 'hidden',
                bgcolor: baseColors.successPreset[20],
            } },
            (function () {
                var isDetailsPage = location.pathname.startsWith(NavigationConfig.ApplicationDetails) ||
                    location.pathname.startsWith(NavigationConfig.BacklogAppDetails);
                var pathSegments = location.pathname.split('/').filter(Boolean);
                var idSegment = pathSegments[1];
                var detailLabel = idSegment ? "AUX - ".concat(idSegment) : undefined;
                return isDetailsPage ? (React.createElement(Header, { detailInfo: ReduxMainRep, appDetailInfo: ReduxAppResp, showBackButton: true, onBack: function () {
                        var _a, _b, _c, _d;
                        if (!location.pathname.startsWith(NavigationConfig.BacklogAppDetails)) {
                            navigate(-1);
                        }
                        else if ((_a = location.state) === null || _a === void 0 ? void 0 : _a.fundingLogRow) {
                            navigate(NavigationConfig.FundingLogManagement, { state: { queueType: (_c = (_b = location.state) === null || _b === void 0 ? void 0 : _b.returnTo) === null || _c === void 0 ? void 0 : _c.queueType } });
                        }
                        else {
                            navigate(NavigationConfig.BacklogManagement, { state: { activeTab: ((_d = location.state) === null || _d === void 0 ? void 0 : _d.activeTab) === 1 ? 1 : 0 } });
                        }
                    }, label: detailLabel })) : (React.createElement(Header, { showSearchBar: location.pathname.startsWith(NavigationConfig.BacklogManagement) || location.pathname.startsWith(NavigationConfig.ApplicationManagement), detailInfo: ReduxMainRep }));
            })(),
            accessibleRoutes.some(function (route) { return location.pathname.startsWith(route); })
                ? React.createElement(React.Fragment, null, children)
                : React.createElement(PageNotFound, null))));
};
export default CheckAuth;
